<template>
  <v-app style="height: auto; background: transparent">
    <div>
      <ModuleBase 
        :link="scheduleRequestLink" 
        :bookingLink="scheduleMakeBookingLink" 
        :move-days="1"
        :referer="referer"
        :source="source"
        :module-type="'multiple'"
      ></ModuleBase>
    </div>
  </v-app>
</template>

<script>
import ModuleBase from "../components/ModuleBase";

function addRoistatCounter(roistat_key) {
    var loadRoistat = function(){
      (function(w, d, s, h, id) {
          w.roistatProjectId = id; w.roistatHost = h;
          var p = d.location.protocol == "https:" ? "https://" : "http://";
          var u = /^.*roistat_visit=[^;]+(.*)?$/.test(d.cookie) ? "/dist/module.js" : "/api/site/1.0/"+id+"/init?referrer="+encodeURIComponent(d.location.href);
          var js = d.createElement(s); js.charset="UTF-8"; js.async = 1; js.src = p+h+u; var js2 = d.getElementsByTagName(s)[0]; js2.parentNode.insertBefore(js, js2);
        })(window, document, 'script', 'cloud.roistat.com', roistat_key);
  }
  var i = 0;
  var _TIMEOUT = 1000;
  var trackRoistatVisit = function () {
    var regexp = /roistat_visit=([^&]+)/i;
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!regexp.exec(document.location.search)) {
      loadRoistat();
      clearInterval(checkInterval);
    }
    if (i > 10) {
      loadRoistat();
      clearInterval(checkInterval);
    }
    i++;
  };
  var checkInterval = setInterval(trackRoistatVisit, _TIMEOUT);
}

export default {
  components: { ModuleBase },
  name: "App",
  data: () => {
    return {
      scheduleRequestLink: window.schedule_request_link,
      scheduleMakeBookingLink: window.schedule_make_booking_link,
      source: window.source,
      referer: window.referer,
    };
  },
  created: () => {
    if (window.roistat_key) {
      addRoistatCounter(window.roistat_key)
    }
  }
};
</script>
